module.exports = __webpack_public_path__ + "media/images/short_scenario_contest/theme-text@3x-fe1d178c9dde1a9378e8e4d7f690d610.png";